import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import './Accordion.css';
import {
  HomeUpdatedonedev,
  HomeUpdatedtwodev,
  HomeUpdatedthreedev,
  HomeUpdatedfourdev,
  HomeUpdatedfivedev,
  HomeUpdatedsixdev,
  HomeUpdatedsevendev,
  HomeUpdatedeightdev,
  discoveryBackground,
  HomeUpdatedArrowIcon,
} from "../../../app-constants";

const AccordionItem = ({
  title,
  icon,
  contentMainTitle,
  contentTitle,
  content,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="card">
      <div
        className={`card-header ${isOpen ? "active" : ""}`}
        onClick={onToggle}
      >
        {title}
        <div className="svg-arrow-icon d-block d-lg-none">
          {HomeUpdatedArrowIcon}
        </div>
      </div>
      <div className={`collapse ${isOpen ? "show width" : "width"}`}>
        <div className="card-body">
          <div className="discovery-bg">{discoveryBackground}</div>
          <div className="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              fill="none"
              viewBox="0 0 20 36"
            >
              <path
                stroke="#F47A1F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M1.893 2.377l15.62 15.62-15.62 15.62"
              ></path>
            </svg>
          </div>
          <div
            className="main-title"
            dangerouslySetInnerHTML={{ __html: contentMainTitle }}
          />
          <div class="content-wrap">
            <div class="icon">{icon}</div>
            <h3
              className="title"
              dangerouslySetInnerHTML={{ __html: contentTitle }}
            />
            <p dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    </div>
  );
};

function DiscoveryAcc() {
  const [activeIndex, setActiveIndex] = useState(0);

  // const handleToggle = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  const handleToggle = (index) => {
    // Set activeIndex to the clicked index if it's different from the current active index
    setActiveIndex(activeIndex === index ? activeIndex : index);
  };

  return (
    <section className="tekrevol-home-discovery overflow-x-hidden ionic-process-pathway">
      <div className="accordion width" id="accordionHorizontalExample">
        <AccordionItem
          title="Imagine"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedonedev}
          contentTitle="Imagine"
          content="We take your vision and align it with the current market trends. Our certified developers analyze thoroughly to define the scope of your project to efficiently allocate resources and plan out the financial considerations within the process of developing the Ionic app."
          isOpen={activeIndex === 0}
          onToggle={() => handleToggle(0)}
        />
        <AccordionItem
          title="Strategize"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedtwodev}
          contentTitle="Strategize"
          content="Our team creates a strategic plan to help in optimizing the development process. We analyze possible costs, workflow bottlenecks, and automated processes so that the development of your Ionic app is both inexpensive and of top quality."
          isOpen={activeIndex === 1}
          onToggle={() => handleToggle(1)}
        />
        <AccordionItem
          title="Design"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedthreedev}
          contentTitle="Design"
          content="With a concrete strategy in place, we move forward with our design process, where our UX/UI experts help us build the best experience possible. The user-centric approach is central to the development, whereby the app functions well across all platforms and assures an engaging user experience."
          isOpen={activeIndex === 2}
          onToggle={() => handleToggle(2)}
        />
        <AccordionItem
          title="Develop"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedfourdev}
          contentTitle="Develop"
          content="With the Ionic framework, we breathe life into your app. We assure you that you receive a high-performing cross-platform mobile application that is feature-rich along with a seamless and responsive user experience."
          isOpen={activeIndex === 3}
          onToggle={() => handleToggle(3)}
        />
        <AccordionItem
          title="Test and Evaluation"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedfivedev}
          contentTitle="Test and Evaluation"
          content="The app is tested rigorously on the grounds of functionality, performance, and compatibility with various devices and platforms. We catch the issues and then fix them so that the app meets our high-quality benchmarks before it is ready for deployment."
          isOpen={activeIndex === 4}
          onToggle={() => handleToggle(4)}
        />
        <AccordionItem
          title="Deploy"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedsixdev}
          contentTitle="Deploy"
          content="When the app has passed all testing phases, we carry out its deployment in the desired platforms. Once everything goes live, our team is behind the scenes, ensuring that users receive your new app as quickly and efficiently as possible."
          isOpen={activeIndex === 5}
          onToggle={() => handleToggle(5)}
        />
        <AccordionItem
          title="Support & Expand"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedsevendev}
          contentTitle="Support & Expand"
          content="We provide support and maintenance services for updating and optimizing your application further in use. We also work to expand and enhance your application, adding new features and functionalities as the business expands."
          isOpen={activeIndex === 6}
          onToggle={() => handleToggle(6)}
        />
        {/* <AccordionItem
          title="Continuous Support & Optimization"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedeightdev}
          contentTitle="Continuous Support & Optimization"
          content="Offer ongoing support and optimization services. Monitor performance, gather feedback, and implement enhancements to drive sustained growth and innovation"
          isOpen={activeIndex === 7}
          onToggle={() => handleToggle(7)}
        /> */}
      </div>
    </section>
  );
}

export default DiscoveryAcc;
